import { AuthContext } from "@contexts/auth/AuthContextProvider";
import { IAuthContext, IDataContextProvider } from "@type";
import { useContext, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { IndividualLoginAuth0Context } from "@providers";

export const useAuthenticatedApi = (
  dataProvider: IDataContextProvider,
  effect: () => void | (() => void),
  ...dependencies: unknown[]
) => {
  const { isLoading, getApiToken } = useContext<IAuthContext>(AuthContext);
  const { isAuthenticated } = useAuth0(IndividualLoginAuth0Context);
  const loading = !isLoading || isLoading();

  useEffect(() => {
    // Only proceed if authenticated - prevents errors during logout
    if (!loading && isAuthenticated && getApiToken) {
      getApiToken()
        .then((authToken) => {
          if (!authToken) {
            throw new Error("Failed to retrieve auth token");
          }
          dataProvider.authenticate(authToken);
        })
        .then(effect)
        .catch((error) => {          
          if (!(error instanceof Error && error.message === 'User not authenticated')) {
            console.error('[useAuthenticatedApi] Error:', error);
          }
        });
    }
  }, [loading, isAuthenticated, ...(dependencies || [])]);
};
